module.exports = __webpack_public_path__ + "static/media/kholusia.c5543c4f.jpg";